import { Link } from "react-router-dom";
import { FileSignature } from "lucide-react";
import { Button } from "../../ui/button";
import { Page, H1, H2, Lead, P, UL, Notice, DocVersion } from "../../public/primitives";
import { legal } from "../../../config/legal";

export const DpaPage = () => (
  <Page testid="dpa-page">
    <H1>Accord de traitement des données (DPA)</H1>
    <Lead>
      Cette page présente les thèmes couverts par un accord de traitement des données entre le client
      et {legal.publisherName}. Version <DocVersion value={legal.dpaVersion} />.
    </Lead>

    <Notice testid="dpa-work-note">
      Il ne s'agit pas d'un DPA juridiquement signé : c'est une présentation des thèmes. Le document
      contractuel définitif sera fourni sur demande avant production commerciale.
    </Notice>

    <H2 id="objet">Objet</H2>
    <P>Encadrer le traitement des données personnelles réalisé par SecurePass pour le compte du client.</P>

    <H2 id="instructions">Instructions du client</H2>
    <P>Le traitement est réalisé selon les instructions documentées du client.</P>

    <H2 id="confidentialite">Confidentialité</H2>
    <P>Les personnes autorisées à traiter les données sont soumises à une obligation de confidentialité.</P>

    <H2 id="securite">Sécurité</H2>
    <P>
      Mesures techniques et organisationnelles : chiffrement côté navigateur, clé séparée du contenu,
      lecture unique, expiration, durcissement HTTP (voir la page
      <Link to="/securite" className="text-emerald-600 underline"> Sécurité</Link>).
    </P>

    <H2 id="sous-traitants">Sous-traitants</H2>
    <P>
      Le recours à des sous-traitants ultérieurs est encadré. La liste actuelle figure sur la page
      <Link to="/sous-traitants" className="text-emerald-600 underline"> Sous-traitants</Link>.
    </P>

    <H2 id="assistance">Assistance</H2>
    <P>Assistance raisonnable au client pour répondre aux demandes des personnes concernées.</P>

    <H2 id="incidents">Incidents</H2>
    <P>Notification des violations de données dans les conditions prévues par la réglementation.</P>

    <H2 id="suppression">Suppression / restitution</H2>
    <P>Suppression ou restitution des données au terme de la prestation, selon le choix du client.</P>

    <H2 id="audit">Audit</H2>
    <P>Mise à disposition des informations nécessaires pour démontrer la conformité.</P>

    <H2 id="localisation">Localisation et transferts</H2>
    <P>
      Les informations relatives à la localisation d'hébergement et aux éventuels transferts seront
      précisées une fois l'hébergeur confirmé (voir Mentions légales).
    </P>

    <div className="mt-8">
      <Link to="/contact?subject=dpa">
        <Button data-testid="dpa-request-btn" className="bg-emerald-500 hover:bg-emerald-400 text-emerald-950 font-semibold">
          <FileSignature className="w-4 h-4 mr-2" /> Demander le DPA
        </Button>
      </Link>
    </div>
  </Page>
);

export default DpaPage;
